const modulePatient = {
	namespaced: true,
	state: {
		patient: null,
        patientRut: null,
		loading: false,
	},
	getters: {
        getPatientRut(state) {
            return state.patientRut;
        },
		getPatient(state) {
			return state.patient;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadPatient(state, patient) {
			state.patient = patient;
		},
        setPatientRut(state, rut) {
            state.patientRut = rut;
        },
        setPatient(state, patient) {
            state.patient = patient;
        }
	}
}

export default modulePatient;